import request from '@/utils/request'

// 生产环境api路径

export function getCount (data) {
  return request({
    url: '/old/linkcount',
    method: 'POST',
    data
  })
}
export function sendEmail (data) {
  return request({
    url: '/old/autologinmailsend',
    method: 'POST',
    data
  })
}

export function getUrl (data) {
  return request({
    url: '/old/autologinurl',
    method: 'POST',
    data
  })
}

// 判断是否登录
export function isLogin () {
  return request({
    url: '/old/logincheck',
    method: 'get'
  })
}

// 开发环境api路径

// export function getCount (data) {
//   return request({
//     url: 'api/linkcount',
//     method: 'POST',
//     data
//   })
// }

// export function sendEmail (data) {
//   return request({
//     url: 'api/autologinmailsend',
//     method: 'POST',
//     data
//   })
// }

// export function getUrl (data) {
//   return request({
//     url: 'api/autologinurl',
//     method: 'POST',
//     data
//   })
// }

// // 判断是否登录
// export function isLogin () {
//   return request({
//     url: 'api/logincheck',
//     method: 'get'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/mobile.js